import SpawnPoint from '@/cells/SpawnPoint'
import { LEFT } from '@/constants/Directions'

export default class SpawnPointToLeft extends SpawnPoint {
    public defaultDirection = LEFT
}
